<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

</script>
<template>
  <footer class="footer">
    <ul class="footer__company-info">
      <li>{{ t('common.companyName') }}</li>
      <li>{{ t('common.companyCeo') }}</li>
      <li>{{ t('common.companyBusinessNumber') }}</li><br>
      <li>{{ t('common.companyAddr') }}</li>
      <li>{{ t('common.companyNumber') }}</li>
      <li>{{ t('common.companyFax') }}</li>
    </ul>
    <div class="footer__company-link">
      <ul>
        <li>
          <RouterLink to="/terms">
            {{ t('common.terms') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/privacy">
            {{ t('common.privacy') }}
          </RouterLink>
        </li>
      </ul>
      <h4 class="footer__company-copy">
        All Rights Reserved. Copyright@i2max.lnc
      </h4>
    </div>
    <!-- <img
      src="https://yeorcqadlpopsmgaoudu.supabase.co/storage/v1/object/public/certification/mark/2518f911-4b3e-43d9-830b-468e0add1b5a/07b9f4f3-0e50-4162-8e02-a08ade684969-2024-11-28T08:30:24.893Z"
      onclick="(function(){window.open('https://cleanspam.or.kr/ci/164','_blank','width=800, height=1151, toolbar=no, menubar=no, scrollbars=no, resizable=no')})()"
      style="cursor: pointer; width: 54px; height: 54px;"
    > -->
  </footer>
</template>
